import React, { useContext } from "react";
import { AuthContext } from "./../index";
import { Button, Modal } from "antd";
import Helper from "./../../../extra/helper";
import History from "./../../../routes/history";
import cartdone from "./../../../assets/pvi-benhhiemngheo/idone.svg";

const ModalDone = (props) => {
  const { dataCheckReDeem, ArrPackage, dataIsu } = useContext(AuthContext);

  const NewCreate = () => {
    window.location.reload();
    CustomResetLocalStorage();
    props.OpenDone();
    let platform = Helper.getParamUrlByKey("platform");
    if (platform === "app") {
      History.replace("/gotohome");
    }
  };

  const CustomResetLocalStorage = () => {
    localStorage.removeItem('dataIsu');
    localStorage.removeItem('databuyer');
    localStorage.removeItem('vatBHN');
    localStorage.removeItem('listInsured');
  };

  const netxPayment = () => {
    CustomResetLocalStorage();
    let platform = Helper.getParamUrlByKey("platform");
    if (platform === "app") {
      History.replace("/gotocart/" + props.dataOrder.orderCode);
    } else {
      window.location.replace(props.dataOrder.paymentUrl);
    }
  };
  let fee = +props?.dataOrder?.fees;
  let status = +props?.dataOrder?.statusId
  let paymentStatusCode = +props?.dataOrder?.paymentStatusCode === 'PaymentSuccess' ? true : false
  return (
    <div style={{ overflow: "hidden" }}>
      <Modal
        style={{ fontSize: 15 }}
        footer={false}
        closable={false}
        open={true}
        centered={true}
      // maskStyle={{ background: "#000", opacity: 0.8, maxHeight: "100vh"}}
      >
        <div>
          <div style={{ textAlign: "center" }}>
            <img src={cartdone} alt="home" width="95px" height="auto" />
            <div>
              <div style={{ marginTop: 10, fontWeight: 600, fontSize: 20 }}>
                {Helper.getParamUrlByKey("platform") === "app" ? 'Đã thêm vào giỏ hàng' : 'Xác nhận đơn hàng thành công'}
              </div>
              <div style={{ marginTop: 4, fontSize: 18, textAlign: 'justify' }}>
                Đơn hàng{" "}
                <span style={{ fontWeight: 600 }}>Bảo hiểm bệnh hiểm nghèo</span>{" "}
                đã được {(+status === 2 || paymentStatusCode) ? "thanh toán" : Helper.getParamUrlByKey("platform") === "app" ? "thêm vào giỏ hàng" : "khởi tạo"}{" "}
                <span style={{ fontWeight: 600 }}>thành công</span>.
              </div>
            </div>
            <div style={{ fontWeight: 600, marginTop: "2%" }}>
              {props.createOrder?.paymentDescription}
            </div>
            {(+status === 2 || paymentStatusCode) ? (
              <div
                style={{
                  textAlign: "center",
                  marginTop: 15,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  onClick={() => NewCreate()}
                  style={{
                    width: "47%",
                    fontSize: 12,
                    borderRadius: 7,
                    height: 42,
                    fontWeight: "bold",
                    color: "#2A3790",
                    border: "1px solid #2A3790",
                  }}
                  color="#009B4B"
                >
                  Tiếp tục mua hàng
                </Button>
              </div>
            ) : (
              <div
                style={{
                  textAlign: "center",
                  marginTop: 15,
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Button
                  onClick={() => netxPayment()}
                  style={{
                    width: "100%",
                    fontSize: 16,
                    background: "#2A3790",
                    borderRadius: 7,
                    height: 46,
                    fontWeight: "bold",
                    color: "#ffffff",
                  }}
                  color="#009B4B"
                >
                  {Helper.getParamUrlByKey("platform") === "app"
                    ? "Đến giỏ hàng"
                    : "Thanh toán ngay"}
                </Button>
              </div>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ModalDone;
